/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Card, CardBody, CardTitle } from "reactstrap";

import Carousel from "nuka-carousel";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { getDashboards } from "../../store/dashboard/actions";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import firebase from "../../firebase";
import axios from "axios";

import "./index.scss";
import { isArray } from "../../Libs/CustomMethods/customMethods";

const Dashboard = ({ t }) => {
  const dispatch = useDispatch();

  const { data: dataLogin } = useSelector((state) => state.Login);
  const { mainTheme } = useSelector((state) => state.Layout);
  const { dataDashboard, loadingDashboard } = useSelector(
    (state) => state.Dashboards
  );

  const tgEmbed = "embed";
  const tgGeneral = "general";
  const tgSkills = "skill";
  const tgLinks = "link";

  const [isList, setIsList] = useState({
    [tgGeneral]: false,
    [tgSkills]: false,
  });

  const [generalMsg, setGeneralMsg] = useState([]);
  const [skilllMsg, setSkillMsg] = useState([]);
  const [usefulLinks, setUsefulLinks] = useState([]);
  const [embed, setEmbed] = useState([]);

  const toggleList = (target) => {
    setIsList({ ...isList, [target]: !isList[target] });
  };

  const renderNotFound = () => {
    return (
      <div className="d-flex no-matching-records h-100 justify-content-center">
        <span className="d-flex align-self-center">
          {t("No matching records found")}
        </span>
      </div>
    );
  };

  const renderLoading = () => {
    return (
      <div className="no-matching-records">
        <span>{t("Loading...")}</span>
      </div>
    );
  };

  const renderList = (data, isLink) => {
    return (
      <PerfectScrollbar className="pr-3">
        <ul>
          {data.map((element, key) => (
            <li key={key} className="text-justify mb-1">
              {isLink ? (
                <a
                  className={`font-size-14 useful-links ${mainTheme}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={element?.info?.url}
                >
                  {element?.info?.title}
                </a>
              ) : (
                element?.message
              )}
            </li>
          ))}
        </ul>
      </PerfectScrollbar>
    );
  };

  const renderCarousel = (data) => {
    return (
      <Carousel autoplay wrapAround>
        {data.map((e, key) => (
          <div
            key={key}
            className="d-flex px-2 pb-5 dashboard-card messages text-center justify-content-center"
          >
            <PerfectScrollbar className="d-flex justify-content-center p-3">
              <div className="align-self-center">{e.message}</div>
            </PerfectScrollbar>
          </div>
        ))}
      </Carousel>
    );
  };

  const switchInfoType = (info) => {
    const type = `${info.type}`;

    let videoType = "video/ogg";
    if (type === "video") {
      const src = info?.src;
      if (src.includes(".mp4")) {
        console.log("mp4");
        videoType = "video/mp4";
      }
      if (src.includes(".webm")) {
        console.log("webm");
        videoType = "video/webm";
      }
    }

    switch (type) {
      case "image":
        return (
          <img
            className="overflow-hidden align-self-center"
            src={info?.src}
            alt={info?.title}
            width={info?.width || "100%"}
            height={info?.height || "100%"}
            referrerPolicy="no-referrer"
          />
        );
      case "iframe":
        return (
          <iframe
            className="overflow-hidden align-self-center"
            src={info?.src}
            title={info?.title}
            width={info?.width || "100%"}
            height={info?.height || "100%"}
            referrerPolicy="no-referrer"
          />
        );
      case "video":
        return (
          <video
            className="overflow-hidden align-self-center"
            width={info?.width || "100%"}
            height={info?.height || "100%"}
            controls
          >
            <source src={info?.src} type={videoType} />
          </video>
        );
      case "audio":
        return (
          <audio className="overflow-hidden align-self-center" controls>
            <source src={info?.src} />
          </audio>
        );
      default:
        break;
    }
  };

  const renderEmbed = (data) => {
    return (
      <>
        <Carousel
          wrapAround
          defaultControlsConfig={{ prevButtonText: "<", nextButtonText: ">" }}
        >
          {data.map((e, key) => (
            <div
              key={key}
              className="d-flex px-2 pb-5 dashboard-card messages text-center justify-content-center"
            >
              <PerfectScrollbar className="d-flex w-100 h-100 justify-content-center p-3">
                <div className="d-flex w-100 h-100 justify-content-center">
                  {switchInfoType(e?.info)}
                </div>
              </PerfectScrollbar>
            </div>
          ))}
        </Carousel>
      </>
    );
  };

  const renderGeneral = (data, target) => {
    return isList[target] ? renderList(data) : renderCarousel(data);
  };

  const renderSkill = (data, target) => {
    return isList[target] ? renderList(data) : renderCarousel(data);
  };

  const renderLink = (data) => {
    return renderList(data, true);
  };

  const switchData = (target, data) => {
    switch (target) {
      case tgEmbed:
        return renderEmbed(data);
      case tgGeneral:
        return renderGeneral(data, tgGeneral);
      case tgSkills:
        return renderSkill(data, tgSkills);
      case tgLinks:
        return renderLink(data);
      default:
        break;
    }
  };

  const renderCard = (title, target, data) => {
    return (
      <Card className="message-card">
        <CardBody>
          <CardTitle className="d-flex justify-content-between">
            <div className="d-flex">{t(title)}</div>
            {switchCardHeader(target)}
          </CardTitle>
          <Row>
            <Col
              xs="12"
              className={`dashboard-card messages ${mainTheme} ${target}`}
            >
              {loadingDashboard?.dashboard
                ? renderLoading()
                : data.length > 0
                ? switchData(target, data)
                : renderNotFound()}
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  };

  const switchCardHeader = (target) => {
    switch (target) {
      case tgSkills:
      case tgGeneral:
        return (
          <div className="d-flex">
            <i
              id={`list-${target}`}
              className={`font-size-18 bx bx-list-ul bx-xs align-self-center pointer ${
                isList[target] ? "text-primary" : ""
              }`}
              onClick={() => toggleList(target)}
            />
          </div>
        );
      default:
        break;
    }
  };

  const setDataValues = (data) => {
    let embedArray = [];
    let generalArray = [];
    let skillArray = [];
    let linkArray = [];
    data.forEach((element) => {
      switch (element?.category) {
        case tgEmbed:
          embedArray.push(element);
          break;
        case tgGeneral:
          generalArray.push(element);
          break;
        case tgSkills:
          skillArray.push(element);
          break;
        case tgLinks:
          linkArray.push(element);
          break;
        default:
          break;
      }
    });
    setEmbed(embedArray);
    setGeneralMsg(generalArray);
    setSkillMsg(skillArray);
    setUsefulLinks(linkArray);
  };

  useEffect(() => {
    if (isArray(dataDashboard?.dashboard)) {
      setDataValues(dataDashboard?.dashboard);
    }
  }, [dataDashboard]);

  useEffect(() => {
    const msg = firebase.messaging();
    msg
      .requestPermission()
      .then(() => {
        return msg.getToken();
      })
      .then((token) => {
        console.warn("token do usuário:",token)
        updateToken(token);
      })
      .catch(() => {
        cleanToken();
      })
    dispatch(getDashboards("dashboard"));
  }, []);

  const cleanToken = async () => {
    try {
      const response = await axios.patch(`/user/push`, {});
      if (response.status === 200) {
        console.log(response.data);
      } else throw response.data;
    } catch (error) {}
  }
  
  const updateToken = async (token) => {
    try {
      const response = await axios.patch(`/user/push`, { token: token });
      if (response.status === 200) {
        console.log(response.data);
      } else throw response.data;
    } catch (error) {}
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/dashboard"
            title={t("Welcome")}
            breadcrumbItem={t("Dashboard")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="d-flex flex-column card-height">
                  <Row>
                    <Col xs="12" className="font-size-16 font-weight-bold pb-2">
                      <div className="d-flex w-100 justify-content-between">
                        <div>
                          {t("Welcome to") + " " + dataLogin?.company?.name}
                        </div>
                        <i
                          id={`update-dashboard`}
                          className={`font-size-18 bx bx-refresh bx-xs ml-1 align-self-center pointer ${
                            loadingDashboard?.dashboard
                              ? "loading-spinning"
                              : ""
                          }`}
                          onClick={() => dispatch(getDashboards("dashboard"))}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12">
                      {renderCard(t("General"), tgEmbed, embed)}
                    </Col>
                  </Row>
                  {/* // TODO: uncomment the code below when you have messages by skill and general messages  */}
                  {/* <Row>
                    <Col xs="12" md="6">
                      {renderCard("General Messages", tgGeneral, generalMsg)}
                    </Col>
                    <Col xs="12" md="6">
                      {renderCard("Skill Messages", tgSkills, skilllMsg)}
                    </Col>
                  </Row> */}
                  <Row>
                    <Col xs="12">
                      {renderCard(t("Useful Links"), tgLinks, usefulLinks)}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Dashboard);
